import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export interface DialogTabNavItem {
  id: string;
  label: string;
  icon?: IconProp;
  count?: number;
}

@Component({
  selector: 'app-dialog-tab-nav',
  templateUrl: './dialog-tab-nav.component.html',
  styleUrl: './dialog-tab-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class DialogTabNavComponent {
  readonly tabs = input<DialogTabNavItem[]>([]);
  readonly activeId = input<string | null>(null);
  readonly invalidIds = input<string[]>([]);
  readonly invalidCounts = input<Record<string, number>>({});
  readonly tabSelect = output<string>();

  readonly warningIcon = faExclamationTriangle;

  isActive(tabId: string): boolean {
    return this.activeId() === tabId;
  }

  isInvalid(tabId: string): boolean {
    return this.invalidIds().includes(tabId);
  }

  getInvalidCount(tabId: string): number | undefined {
    const count = this.invalidCounts()[tabId];
    return count && count > 0 ? count : undefined;
  }

  onTabClick(tabId: string): void {
    this.tabSelect.emit(tabId);
  }
}
